module.exports = __webpack_public_path__ + "media/components/page-quote/components/quote-info/progress-icon-2-c699d85299fbecaf5360f03fbc20a7dc.svg";